/**
 * The searched code after the API has classified and normalised it (see InventorySearch.Response.ParsedCode).
 * Equivalent inputs produce the same value, e.g. 228 and 00228 both give a Numeric code with the value 228.
 */
export interface IParsedCode {
    input: string
    type: "Numeric" | "Date" | "AlphaNumeric" | string
    value: string
}

/**
 * The reference to use for an assumed match (a range result that is requested as a case that doesn't exist yet).
 *
 * Numeric codes are stored in their parsed form, so the parsed value is used (00228 => 228).
 * That makes 228 and 00228 the same reference, so they can't both be added to a recall and don't create duplicate cases.
 * Other code types keep what the user typed, as their parsed value is not a usable reference
 * (e.g. packed ASCII for alphanumeric codes).
 */
export function getAssumedItemReference(submittedCode: string | null | undefined, parsedCode: IParsedCode | null | undefined): string | null | undefined {
    if (parsedCode?.type === "Numeric") {
        return parsedCode.value
    }
    return submittedCode
}
